import PrizeLandingPage from 'components/prize-landing-pages/PrizeLandingPage';
import MainLayout from 'components/layout/MainLayout';
import { ASSET_PREFIX } from 'utils/constants';
import GreenPageSection from 'components/GreenPageSection';
import Subheading from 'components/Subheading';
import RoundedButton from 'components/RoundedButton';
import ImageWithContentSection from 'components/prize-landing-pages/ImageWithContentSection';
import React from 'react';
import { scrollToSection } from 'utils/common';
import WinnerContentSection from 'components/prize-landing-pages/WinnerContentSection';
import { NextSeo } from 'next-seo';
import HowItWorksAndChoosePlanSection
  from 'components/prize-landing-pages/HowItWorksAndChoosePlanSection';

const WinACamperVan = () => {
  const imageDirectory = `${ASSET_PREFIX}/images/prize-landing-pages/win-a-camper-van`;

  const handleScrollToEntryMethodCards = () => {
    scrollToSection('#howItWorksAndChoosePlanSection');
  };

  return (
    <MainLayout paddedMaxWidthContainer={false}>
      <NextSeo
        title="DAYMADE | Win A Live-In Camper Van Worth £100k"
        description="Enter our weekly draw for the chance to win a custom live-in camper van plus £20,000 in spending money!"
        canonical='https://www.daymade.co.uk/prizes/details/win-camper-van'
        openGraph={{
          title: 'DAYMADE | Win A Live-In Camper Van Worth £100k',
          description: 'Enter our weekly draw for the chance to win a custom live-in camper van plus £20,000 in spending money!',
        }}
      />

      <div id="top-of-page" />

      <PrizeLandingPage>
        <img
          src={`${imageDirectory}/hero.png`}
          className='hero'
          alt="old VW camper van stopped on road with roof-bed opened up on top"
        />

        <GreenPageSection additionalClassName='pageTitleGreenSectionContainer'>
          <Subheading Tag='h1' className='pageTitle'>
            Win A Live-In Camper Van<br />
            <span style={{ fontSize: '2em', display: 'block' }}>
              Worth&nbsp;<strong>£100k</strong>
            </span>
          </Subheading>
          <p>
            Enter our weekly draw for the chance to win a custom live-in camper van plus £20,000 in spending money!
          </p>
          <RoundedButton onClick={handleScrollToEntryMethodCards} style={{ width: 280 }}>
            Enter Now
          </RoundedButton>
          <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', margin: '3em 1em 0', width: '100%', maxWidth: 450 }}>
            <a href='https://uk.trustpilot.com/review/daymade.co.uk' target='_blank' style={{ margin: '0 0 2em 0', width: '35%' }}>
              <img src={`${ASSET_PREFIX}/images/play-free-lp/trustpilot-logo-grey.svg`} style={{ width: '100%' }} />
            </a>
            <a href='https://www.veritree.com/' target='_blank' style={{ margin: '0 0 2em 0', width: '50%', display: 'flex', alignItems: 'center', textAlign: 'left', wordBreak: 'break-word', whiteSpace: 'break-spaces' }}>
              <img src={`${ASSET_PREFIX}/images/veritree-logo-dark.svg`} style={{ width: '25%', marginRight: '0.5em' }} />
              Plant a tree with every purchase
            </a>
          </div>
        </GreenPageSection>

        <ImageWithContentSection
          subheadingText={<>Could You Be The Next <strong>Winner?</strong></>}
          imageSrc={`${imageDirectory}/secondary1.png`}
          imageAltText="grid of images showing friends on holiday camping in old VW camper-van"
        >
          <p>
            As a team of 5 renters, we know all too well how crappy the housing market crisis is! So we thought: why not offer a very very epic solution to this problem: your very own house on wheels! Plus, if you've got the travel bug (and we assume you do if you're a DAYMADE player!), what's better than a house that can take you literally anywhere on the planet? Your adventure awaits.
          </p>

          <div className='ctaContainer'>
            <RoundedButton onClick={handleScrollToEntryMethodCards} style={{ width: 280 }}>
              Enter Now
            </RoundedButton>
          </div>
        </ImageWithContentSection>

        <ImageWithContentSection
          subheadingText={<>What's <strong>Included?</strong></>}
          imageSrc={`${imageDirectory}/secondary2.png`}
          imageAltText="couple stood outside VW camper-van by a wood fire"
          reverseDesktopDirection
        >
          <ul style={{ fontWeight: 600 }}>
            <li>
              Brand new FIAT NEW DUCATO 35 LH2 2.2 MULTIJET III 140 HP TECNICO or similar
            </li>

            <li>
              A choice of at least 5 fully furnished live-in camper vans with a contemporary homely feel throughout with high spec appliances and finishes
            </li>

            <li>
              Double bed
            </li>

            <li>
              Kitchen
            </li>

            <li>
              Shower room
            </li>

            <li>
              Warranty
            </li>

            <li>
              £20,000 spending money
            </li>
          </ul>

          <div className='ctaContainer'>
            <RoundedButton onClick={handleScrollToEntryMethodCards} style={{ width: 280 }}>
              Enter Now
            </RoundedButton>
          </div>
        </ImageWithContentSection>

        <img
          src={`${ASSET_PREFIX}/images/prize-landing-pages/winner-row-1.png`}
          style={{
            width: '100%',
          }}
        />

        <WinnerContentSection
          onCtaClick={handleScrollToEntryMethodCards}
        />

        <img
          src={`${ASSET_PREFIX}/images/prize-landing-pages/winner-row-2.png`}
          style={{
            width: '100%',
          }}
        />

        <HowItWorksAndChoosePlanSection />
      </PrizeLandingPage>
    </MainLayout>
  );
};

export default WinACamperVan;
